export const Footer = () => {
  return (
    <footer>
      <p>&copy; {new Date().getFullYear()} Gardrobe. All rights reserved.</p>
    </footer>
  );
};
